import { Action } from '../../shared/models/action.model';
import { FormControlConfig } from '../../shared/models/formControlConfig.model';
import { Payer } from '../../shared/models/payer.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/payerListTypes';

export const changePayer = (payer: Payer): Action<Payer> => updateAction(actionTypes.CHANGE_PAYER, payer);

export const updateFormControlConfig =
  (formControlConfig: FormControlConfig): Action<FormControlConfig> =>
    updateAction(actionTypes.UPDATE_FORM_CONTROL_CONFIG, formControlConfig);

export const setAllPayers = (allPayers: Payer[]): Action<Payer[]> =>
  updateAction(actionTypes.SET_ALL_PAYERS, allPayers);

export const setReimbursementPayers = (payers: Payer[]): Action<Payer[]> =>
  updateAction(actionTypes.SET_REIMBURSEMENT_PAYERS, payers);

export const setGrievancePayers = (payers: Payer[]): Action<Payer[]> =>
  updateAction(actionTypes.SET_GRIEVANCE_PAYERS, payers);

export const setExactFileCount = (exactFileCount: number): Action<any> =>
  updateAction(actionTypes.SET_EXACT_FILE_COUNT, exactFileCount);
